<input class="form-control" [(ngModel)]="contextualSearchString" (keyup)="inputChanged($event)" placeholder="placeholderText" />
